import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { StatusSelect } from "shared";
import {
  Control,
  FieldErrors,
  UseFormRegister,
  UseFormWatch,
  useFieldArray,
} from "react-hook-form";
import { OmittedEmployee } from "entitites/employees/model/employee";

export const PersonalBody = ({
  register,
  errors,
  control,
  watch,
}: {
  register: UseFormRegister<OmittedEmployee>;
  errors: FieldErrors<OmittedEmployee>;
  control: Control<OmittedEmployee>;
  watch: UseFormWatch<OmittedEmployee>;
}) => {
  const { fields, append, remove } = useFieldArray({
    name: "personalInfo.additionalFields",
    control,
  });
  return (
    <Box width="100%" display="flex" gap={1.25} flexDirection="column">
      <Typography fontWeight={700} color="green.primary" variant="h6">
        Личная информация
      </Typography>
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Статус
        <StatusSelect
          value={watch("personalInfo.statusId")}
          inputProps={register("personalInfo.statusId", {
            required: "Пожалуйста введите статус",
          })}
          error={Boolean(errors.personalInfo?.statusId)}
          helperText={errors.personalInfo?.statusId?.message}
          sx={{ ml: "auto", width: 400 }}
        />
      </Box>
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Личная почта
        <TextField
          inputProps={register("personalInfo.personalEmail", {
            required: "Пожалуйста введите личную почту",
          })}
          error={Boolean(errors.personalInfo?.personalEmail)}
          helperText={errors.personalInfo?.personalEmail?.message}
          label="Личная почта"
          size="small"
          sx={{
            ml: "auto",
            width: 400,
          }}
        />
      </Box>
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Рабочая почта
        <TextField
          inputProps={register("personalInfo.email", {
            required: "Пожалуйста введите рабочую почту",
          })}
          error={Boolean(errors.personalInfo?.email)}
          helperText={errors.personalInfo?.email?.message}
          label="Почта"
          size="small"
          sx={{
            ml: "auto",
            width: 400,
          }}
        />
      </Box>
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Личный номер
        <TextField
          inputProps={register("personalInfo.personalPhone", {
            required: "Пожалуйста введите личный номер",
          })}
          error={Boolean(errors.personalInfo?.personalPhone)}
          helperText={errors.personalInfo?.personalPhone?.message}
          label="Личный номер"
          size="small"
          sx={{
            ml: "auto",
            width: 400,
          }}
        />
      </Box>
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Рабочий номер
        <TextField
          inputProps={register("personalInfo.phone", {
            required: "Пожалуйста введите рабочий номер",
          })}
          error={Boolean(errors.personalInfo?.phone)}
          helperText={errors.personalInfo?.phone?.message}
          label="Рабочий номер"
          size="small"
          sx={{
            ml: "auto",
            width: 400,
          }}
        />
      </Box>
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Телеграм
        <TextField
          inputProps={register("personalInfo.telegram", {
            required: "Пожалуйста введите телеграм",
          })}
          error={Boolean(errors.personalInfo?.telegram)}
          helperText={errors.personalInfo?.telegram?.message}
          label="Телеграм"
          size="small"
          sx={{
            ml: "auto",
            width: 400,
          }}
        />
      </Box>
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Город
        <TextField
          inputProps={register("personalInfo.city", {
            required: "Пожалуйста введите город",
          })}
          error={Boolean(errors.personalInfo?.city)}
          helperText={errors.personalInfo?.city?.message}
          label="Город"
          size="small"
          sx={{
            ml: "auto",
            width: 400,
          }}
        />
      </Box>
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Дата рождения
        <TextField
          inputProps={register("personalInfo.dob", {
            required: "Пожалуйста введите дату рождения",
          })}
          error={Boolean(errors.personalInfo?.dob)}
          helperText={errors.personalInfo?.dob?.message}
          label="Дата рождения"
          size="small"
          sx={{
            ml: "auto",
            width: 400,
          }}
        />
      </Box>
      <Box display="flex" alignItems="center" fontWeight={600} width="100%">
        Адрес
        <TextField
          inputProps={register("personalInfo.address", {
            required: "Пожалуйста введите адрес",
          })}
          error={Boolean(errors.personalInfo?.address)}
          helperText={errors.personalInfo?.address?.message}
          label="Адрес"
          size="small"
          sx={{
            ml: "auto",
            width: 400,
          }}
        />
      </Box>
      {fields.map((field, index) => (
        <Box
          key={field.id}
          display="flex"
          alignItems="center"
          fontWeight={600}
          width="100%"
          gap={1}
        >
          <TextField
            inputProps={register(
              `personalInfo.additionalFields.${index}.label`
            )}
            label="Название"
            size="small"
            fullWidth
          />
          <TextField
            inputProps={register(
              `personalInfo.additionalFields.${index}.value`
            )}
            label="Значение"
            size="small"
            fullWidth
          />
          <Button
            disableTouchRipple
            disableElevation
            sx={{
              textTransform: "none",
              fontWeight: 700,
              minWidth: 32,
            }}
            variant="contained"
            onClick={() => remove(index)}
          >
            -
          </Button>
        </Box>
      ))}
      <Button
        disableTouchRipple
        disableElevation
        sx={{
          textTransform: "none",
          fontWeight: 700,
        }}
        variant="contained"
        onClick={() => append({ label: "", value: "" })}
      >
        Добавить личную информацию +
      </Button>
    </Box>
  );
};
